//this reducer is used to approved landUse application data for purchasableFAR form.

import { types } from "../actions/formPurchasableFar";

const initialState = {
  applicationData: null,
  isAppDataLoading: false,
  error: null,
};

const applicationDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_APPLICATION_DATA:
      return {
        ...state,
        applicationData: action.payload.data,
        isAppDataLoading: action.payload.isLoading,
        error: action.payload.error,
      };

    default:
      return state;
  }
};

export default applicationDataReducer;
